module.exports = __webpack_public_path__ + "static/media/application_engineering.2c4e372d.png";